import { createAction, props } from '@ngrx/store';
import { HaloConfig } from '@octiga/psa/halo.interface';

export const loadMspHaloConfig = createAction('[MSP Halo] Load Config');
export const loadMspHaloConfigSuccess = createAction('[MSP Halo] Load Config Success', props<{ data: HaloConfig }>());
export const loadMspHaloConfigFailure = createAction('[MSP Halo] Load Config Failure', props<{ error: any }>());

export const updateMspHaloConfig = createAction('[MSP Halo] Update Config', props<{ data: HaloConfig }>());
export const updateMspHaloConfigSuccess = createAction('[MSP Halo] Update Config Success');
export const updateMspHaloConfigFailure = createAction('[MSP Halo] Update Config Failure', props<{ error: any }>());
